export const apiEndPointConstant = {
  authClient: "/a2srv-client"
};
